import React, { useState } from 'react';
import MicrosoftLogin from 'react-microsoft-login';
import { useLocation } from 'react-router-dom';

import LoadingBadge from '../themed/loading-badge';

import authService from '../../services/authService';
import toastService from '../../services/toastService';

import routes from '../../utils/routes';

interface MicrosoftAuth {
	accessToken: string;
	account: { username: string };
}

const CustomMicrosoftLogin: React.FC = () => {
	const [isAuthenticating, setAuthenticating] = useState(false);

	const location = useLocation();

	const authHandler = async (err: Error, data: MicrosoftAuth) => {
		if (err) {
			return toastService.error(err.message);
		}

		if (data) {
			try {
				setAuthenticating(true);
				await authService.loginWithMicrosoftToken(data.accessToken);

				const route: string = location.state
					? location.state.from
					: routes.internalUserDashboard.pathname;

				window.location.pathname = route;
			} catch (error: any) {
				const message = typeof error === 'string' ? error : error.message;
				toastService.error(message);

				setAuthenticating(false);
			}
		}
	};

	return isAuthenticating ? (
		<LoadingBadge message="Just a minute..." />
	) : (
		<MicrosoftLogin
			clientId={process.env.REACT_APP_MICROSOFT_CLIENT_ID}
			authCallback={authHandler}
		/>
	);
};

export default CustomMicrosoftLogin;
